
<template>
    <div class="create-account-component">      
        <DxValidationGroup ref="validationGroupRef">
        <div class="login-header">
            <div><img class="medium-logo" src="../assets/DineSafeSquare.png"/></div>
            <div class="title dinesafe-purple">DineSafeVT</div>
            <div class=" dinesafe-label">Account Setup</div>
        </div>

        <div class='back-button'>
            <DxButton 
                icon="back"
                ref="btnBackRef" 
                type="normal"
                text="Back to LogIn"
                styling-mode="text" 
                @click="btnBackToLogin"               
            />
        </div>  

        <div ref="accountInputsRef" class="create-admin-account-info">

            <div class="dx-field-label dinesafe-label">Login Info</div>
            <div class='create-account-input'>
                <DxTextBox
                    name="txtFirstName"
                    placeholder="First Name"  
                    :show-clear-button="true"
                    width="300"
                    :value.sync="accountInfo.FirstName"
                >       
                    <DxValidator>
                        <DxRequiredRule message="First Name is required" />
                    </DxValidator>
                </DxTextBox>            
            </div>
            <div class='create-account-input'>            
                <DxTextBox
                    name="txtLastName"
                    placeholder="Last Name"  
                    :show-clear-button="true"
                    width="300"
                    :value.sync="accountInfo.LastName"
                >       
                    <DxValidator>
                        <DxRequiredRule message="Last Name is required" />
                    </DxValidator>
                </DxTextBox>            
            </div>
            <div class='create-account-input'>            
                <DxTextBox
                    name="txtEmail"
                    placeholder="E-mail"  
                    :show-clear-button="true"
                    width="300"
                    :value.sync="accountInfo.Email"
                >       
                    <DxValidator>
                        <DxRequiredRule message="E-mail is required" />
                    </DxValidator>
                </DxTextBox>       
            </div>
            <div class='create-account-input'>            
                <DxTextBox
                    name="txtPassword"
                    placeholder="Password"  
                    :show-clear-button="true"
                    mode="password"
                    width="300"
                    stylingMode="underlined"
                    :value.sync="accountInfo.Password"
                >       
                    <DxValidator>
                        <DxRequiredRule message="Password is required" />
                        <DxPatternRule
                            :pattern="passwordPattern"
                            :message="this.$store.state.globals.passwordMessage"
                        />
                    </DxValidator>
                </DxTextBox>        
            </div>
            <div class='create-account-input'>            
                <DxTextBox
                    name="txtConfirmPassword"
                    placeholder="Confirm Password"
                    :show-clear-button="true"
                    mode="password"
                    width="300"
                    :value.sync="accountInfo.ConfirmPassword"
                >       
                    <DxValidator>
                        <DxRequiredRule message="Confirm your password" />
                        <!-- 
                            AJT - DxCompareRule does not work, it shows the value as invalid no matter what.  This looks to be a DevExtreme bug.
                            I'm able to get around it by using a DxCustomRule instead 
                        -->
                        <!--<DxCompareRule
                            :comparison-target="comparePasswords"
                            type="compare"
                            message="Passwords do not match"
                        />-->
                        <DxCustomRule
                            :validation-callback="comparePasswords"
                            type="custom"
                            message="Passwords do not match"
                        />
                    </DxValidator>
                </DxTextBox>
            </div>

            <div class="dx-field-label dinesafe-label">Business Info</div>
            <div class='create-account-input'>            
                <DxTextBox
                    name="txtBusinessName"
                    placeholder="Business Name"
                    :show-clear-button="true"
                    width="300"
                    :value.sync="accountInfo.BusinessName"
                >       
                    <DxValidator>
                        <DxRequiredRule message="Business Name is required" />
                    </DxValidator>
                </DxTextBox>
            </div>
            <div class='create-account-input'>            
                <DxTextBox
                    name="txtBusinessDescription"
                    placeholder="Business Description"
                    :show-clear-button="true"
                    width="300"
                    :value.sync="accountInfo.BusinessDesc"
                />
            </div>
            <div class='create-account-input'>            
                <DxTextBox
                    name="txtPhoneNumber"
                    placeholder="Phone Number"
                    mask= '+1 (000) 000-0000'
                    :show-clear-button="true"
                    width="300"
                    :value.sync="accountInfo.PhoneNumber"
                >       
                    <DxValidator>
                        <DxRequiredRule message="Phone Number is required" />
                    </DxValidator>
                </DxTextBox>
            </div>
            <div class='create-account-input'>            
                <DxTextBox
                    name="txtAddress"
                    placeholder="Address"
                    :show-clear-button="true"
                    width="300"
                    :value.sync="accountInfo.StreetAddress"
                >       
                    <DxValidator>
                        <DxRequiredRule message="Address is required" />
                    </DxValidator>
                </DxTextBox>
            </div>
            <div class='create-account-input'>            
                <DxTextBox
                    name="txtCity"
                    placeholder="City"  
                    :show-clear-button="true"
                    width="300"
                    :value.sync="accountInfo.City"
                >       
                    <DxValidator>
                        <DxRequiredRule message="City is required" />
                    </DxValidator>
                </DxTextBox>       
            </div>
            <div class="create-account-input">
                <DxSelectBox
                    :items="states"
                    :value.sync="accountInfo[0].StateProvince"
                    :show-clear-button="true"
                    placeholder="State/Province"
                >       
                    <DxValidator>
                        <DxRequiredRule message="State/Province is required" />
                    </DxValidator>
                </DxSelectBox>
            </div>
            <div class='create-account-input'>            
                <DxTextBox
                    name="txtPostalCode"
                    placeholder="Postal Code"
                    :show-clear-button="true"
                    width="300"
                    :value.sync="accountInfo.PostalCode"
                >       
                    <DxValidator>
                        <DxRequiredRule message="Postal Code is required" />
                    </DxValidator>
                </DxTextBox>
            </div>
            <div class='create-account-input'>            
                <DxTextBox
                    name="txtWebsiteURL"
                    placeholder="Website URL"
                    :show-clear-button="true"
                    width="300"
                    :value.sync="accountInfo.WebsiteURL"
                >       
                </DxTextBox>
            </div>
                        <div class='create-account-input'>            
                <DxTextBox
                    name="txtMenuURL"
                    placeholder="Menu URL"
                    :show-clear-button="true"
                    width="300"
                    :value.sync="accountInfo.MenuURL"
                >       
                </DxTextBox>
            </div>
            <div class='continue-to-payment'>
                <DxButton 
                    ref="btnCreateAccountOkRef" 
                    type="normal"
                    text="Continue to Payment Options"
                    styling-mode="outlined" 
                    :visible="true"                
                    @click="btnPaymentOptionsClick"
                />
            </div>
        </div>    

        <div class='continue-to-payment'>
            <DxButton 
                icon="back"
                ref="btnModifyAccountInfoRef" 
                type="normal"
                text="Back to Account Info"
                styling-mode="text" 
                :visible.sync="modifyAccountInfoVisible"                
                @click="btnModifyAccountInfoClick"
            />
        </div>    

        <div ref="ProductInfoRef">
            <p>You are purchasing a DineSafeVT Subscription</p>
            <p><b>Cost: Free for the first month!</b></p>
            <p><b>Then $99.00 per month</b></p>
            <p>Select a payment option, and your subscription will be activated</p>
            <p>You may cancel at any time</p>
        </div>
        <!--<div class="dx-field-label dinesafe-label">Select a payment option</div>-->

        <!--<SocialLogin/>-->

        <!--<div ref="paypalRef" class="paypal-buttons"/>-->

        <!--<div class='center-button'>
            <DxButton 
                ref="btnCreateAccountOkRef" 
                type="normal"
                text="Create Account"
                styling-mode="outlined" 
                :visible="true"
                width="180"
                :disabled="false"
                @click="btnPaymentOptionsClick"
            />
        </div>-->

        <PaymentOptions
            ref="paymentOptionsRef"
            :accountInfo="accountInfo"
        />
        
        </DxValidationGroup>

        <PrivacyPolicyLink />
    </div>
</template>

<script>
    import {DxButton} from 'devextreme-vue';
    import DxTextBox from "devextreme-vue/text-box";
    import SocialLogin from "../../src/components/SocialLogin.vue";
    import PaymentOptions from "../../src/components/payment-options";
    import DxSelectBox from 'devextreme-vue/select-box';
    import DxValidator, { DxRequiredRule, DxCompareRule, DxCustomRule, DxPatternRule } from "devextreme-vue/validator";
    import DxValidationGroup from "devextreme-vue/validation-group";
    import DxValidationSummary from 'devextreme-vue/validation-summary';    
    import notify from 'devextreme/ui/notify';
    import PrivacyPolicyLink from "../../src/components/privacy-policy-link";

    import service from '../../src/data/contact-info-data';

    /*const receiveMessage = (event) => {
        if (event.origin !== "http://example2.org/parent.html") {
            return;
        }
        // Do something here
    }

    document.addEventListener("message", receiveMessage, false);*/
    
    //import {DxForm, DxSimpleItem, DxCompareRule, DxLabel, DxGroupItem, DxRequiredRule, DxPatternRule, DxButtonItem, DxEmptyItem} from 'devextreme-vue/form';

    export default {
        components: {
            DxButton,
            DxTextBox,
            SocialLogin,
            PaymentOptions,
            DxSelectBox,
            DxValidator, DxRequiredRule,
            DxValidationGroup,
            DxCompareRule, DxCustomRule, DxPatternRule,
            DxValidationSummary,
            PrivacyPolicyLink,
        },
        data() {
            const states = service.getStates();

            return {
                passwordPattern: /((?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20})/,
                states:states,
                accountInfo:[
                    {
                        FirstName: null,
                        LastName: null,
                        Email: null,
                        Password: null,
                        ConfirmPassword: null,
                        BusinessName: null,
                        BusinessDesc: null,
                        PhoneNumber: null,
                        StreetAddress: null,
                        StateProvince: 'VT',
                        PostalCode: null,
                        WebsiteURL: null,
                        MenuURL: null,
                    }
                ],
                modifyAccountInfoVisible: false,
            }
        },
        mounted(){
            //Hide the PayPal buttons by default, until the user clicks "CONTINUE TO PAYMENT OPTIONS"
            this.$refs.paymentOptionsRef.$el.hidden = true; //AJT - Comment this to make the PayPal buttons visible, for testing
            this.$refs.ProductInfoRef.hidden = true;
        },
        methods:{
            comparePasswords(e) {
                console.log("comparePasswords");

                //Check if the value for the Password matches the value for Confirm Password
                return this.$data.accountInfo.Password == this.$data.accountInfo.ConfirmPassword;
            },
            formContentReady(e){
              //console.log("formContentReady");
            },
            btnBackToLogin(e){
                //Navigate to the Login page
                this.$router.push("/login-form");
            },
            btnPaymentOptionsClick(e){
                console.log("btnPaymentOptionsClick");

                if(!e.validationGroup.validate().isValid){
                    return;
                }

                //Check if the email address is already in use
                this.$http.post(this.$store.state.appSettings.webServiceUrl + 'GetAccountId',
                {
                    Email: this.$data.accountInfo.Email,
                }
                ).then(function(data){                         
                    if(data.body != null && data.body != ''
                        && JSON.parse(data.body)[0].AccountId != '')
                    {
                        //The email address is already in use for an admin account
                        //Notify the user, do not continue to the Payment Options
                        notify(
                        {
                            message: this.$data.accountInfo.Email + ' already exists', 
                            type:"error", 
                            width:100, 
                            displayTime: 3000,
                            position: {
                                my: 'center center',
                                at: 'center center',
                            }
                        });

                         
                        return;
                    }
                    else
                    {
                        //The email address is not in use for an admin account, so we can continue to the Payment Options

                        if(this.$data.accountInfo.Password != this.$data.accountInfo.ConfirmPassword)
                        {
                            console.log("Passwords do not match");
                        }                

                        //Validate the user inputs.
                        if (e.validationGroup.validate().isValid) 
                        {
                            var accountInfoFix = {
                                FirstName: this.$data.accountInfo.FirstName,
                                LastName: this.$data.accountInfo.LastName,
                                Email: this.$data.accountInfo.Email,
                                Password: this.$data.accountInfo.Password,
                                PhoneNumber: this.$data.accountInfo.PhoneNumber,
                                Address: this.$data.accountInfo.StreetAddress,
                                StateProvince: this.$data.accountInfo[0].StateProvince,
                                PostalCode: this.$data.accountInfo.PostalCode,
                                BusinessName: this.$data.accountInfo.BusinessName,
                                BusinessDesc: this.$data.accountInfo.BusinessDesc,
                                City: this.$data.accountInfo.City,
                                SubscriptionId: '',
                                WebsiteURL: this.$data.accountInfo.WebsiteURL,
                                MenuURL: this.$data.accountInfo.MenuURL,
                                AccountId: '',
                            };

                            //Store the AdminInfo to LocalStorage
                            localStorage.dinesafeData = JSON.stringify(accountInfoFix);
                        }
                        else
                        {
                            //e.validationGroup.validate().brokenRules

                            return; //AJT - For testing the PayPal buttons, comment this to bypass validation
                        }

                        //e.validationGroup.reset();

                        this.$refs.accountInputsRef.hidden = true;
                        this.$refs.paymentOptionsRef.$el.hidden = false;
                        this.modifyAccountInfoVisible = true;
                        this.$refs.ProductInfoRef.hidden = false;
                    }
                });           
            },
            btnModifyAccountInfoClick(e){
                this.$refs.accountInputsRef.hidden = false;
                this.$refs.paymentOptionsRef.$el.hidden = true;
                this.modifyAccountInfoVisible = false;
                this.$refs.ProductInfoRef.hidden = true;
            },
        }
    }
</script>

<style scoped>
    .dinesafe-label{
        padding-bottom:10px;
    }
    .center-button{
        display: flex; 
        justify-content: center;
    }
    .continue-to-payment{
        display: flex; 
        justify-content: center;
        padding-top: 10px;
    }

    .continue-to-payment > .dx-button-mode-outlined{
        color: #147c33;
        border-color: #147c33;
    }

    /*.payment-option{
        padding-top: 30px;
        padding-bottom: 20px;
    }*/

    .dx-field-label{
        width: 100%;
        padding-top: 20px;
    }

    .create-admin-account-info{

    }
</style>

<style lang="scss">
@import "../themes/generated/variables.base.scss";

    .login-header {
    text-align: center;
    margin-bottom: 0px;

    .title {
        
        font-weight: bold;
        font-size: 30px;
        margin: 0;
    }
    }

    .back-button{
        padding-bottom: 0px; 
    }
</style>